function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import keyBy from "lodash/keyBy";
import { useEffect, useRef, useState } from "react";
import { Platform } from "react-native";
import { v4 as uuid } from "uuid";
import { ButtonAccordion } from "./ButtonAccordion";
import { CheckboxListInput } from "./CheckboxListInput";
import { Text } from "./Text";
import { TextInput } from "./TextInput";
import { View } from "./View";
var LINE_HEIGHT = 20;
var BULLET_SIZE = 8;
/**
 * An input for a list of text items
 *
 *
 *
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̅̃̀̀̆̉̀̀̆̎̀̀̆̇̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̆̌̀̀̆́̀̀̇̉̀̀̆̏̀̀̇̅̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆́̀̀̆̌̀̀̆̉̀̀̆̇̀̀̆̎̀̀̂̍̀̀̇̃̀̀̇̄̀̀̆́̀̀̇̂̀̀̇̄̀̀̂̂̀̀̇̍̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̎̀̀̇̄̀̀̆̅̀̀̆̎̀̀̇̄̀̀̂̂̀̀̃̊̀̀̅̋̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̃́̀̀̃̅̀̀̃̄̀̀̃̆̀̀̃̉̀̀̃̃̀̀̆̅̀̀̃̉̀̀̂̍̀̀̃̂̀̀̆̃̀̀̃̄̀̀̃̄̀̀̂̍̀̀̃̄̀̀̆̂̀̀̃̇̀̀̃̇̀̀̂̍̀̀̃̉̀̀̃̇̀̀̆̂̀̀̃̅̀̀̂̍̀̀̃́̀̀̃̄̀̀̆̄̀̀̃̃̀̀̆̄̀̀̆̂̀̀̃̀̀̀̃̂̀̀̃̆̀̀̃̄̀̀̃̅̀̀̃̉̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̆̌̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̉̀̀̆̍̀̀̆́̀̀̆̇̀̀̆̅̀̀̂̍̀̀̃̂̀̀̃̀̀̀̃̂̀̀̃̄̀̀̃̀̀̀̃̇̀̀̃́̀̀̃̉̀̀̂̍̀̀̃́̀̀̃̉̀̀̃́̀̀̃̈̀̀̃̄̀̀̃̃̀̀̂̎̀̀̇̀̀̀̆̎̀̀̆̇̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̈̀̀̆̅̀̀̆̉̀̀̆̇̀̀̆̈̀̀̇̄̀̀̂̂̀̀̃̊̀̀̃́̀̀̃̇̀̀̃́̀̀̂̌̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̅̀̀̃̂̀̀̃̇̀̀̇̍̀̀̇̍̀̀̅̍̀̀̇̍}
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-4}
 */ export function ListItemTextInput(props) {
    var selectionRef = useRef({
        start: 0,
        end: 0
    });
    var items = props.value;
    var value = items.map(function(i) {
        return i.text;
    }).join('\n');
    var _useState = _sliced_to_array(useState(props.label ? 23 : 0), 2), labelHeight = _useState[0], setLabelHeight = _useState[1];
    var ref = useRef(null);
    useEffect(function() {
        if (props.autoFocus) {
            // delay focus a tick so that our suggestions list can render otherwise
            // autoscroll behavior from ScrollView doens't work reliably on Android
            // b/c we don't have any sufficient height to scroll by
            requestAnimationFrame(function() {
                var _ref_current;
                (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.focus();
            });
        }
    }, [
        props.autoFocus
    ]);
    var _props_placeholder, _props_label;
    return /*#__PURE__*/ _jsxs(View, {
        children: [
            /*#__PURE__*/ _jsx(TextInput, {
                ref: ref,
                onLabelLayout: function(e) {
                    setLabelHeight(e.nativeEvent.layout.height);
                },
                "aria-label": props['aria-label'],
                placeholder: (_props_placeholder = props.placeholder) !== null && _props_placeholder !== void 0 ? _props_placeholder : props['aria-label'],
                testID: props.testID,
                label: (_props_label = props.label) !== null && _props_label !== void 0 ? _props_label : undefined,
                error: props.error,
                style: {
                    zIndex: 1
                },
                multiline: true,
                initialContentHeight: props.minHeight,
                textAlignVertical: "top",
                onSelectionChange: function(e) {
                    selectionRef.current = e.nativeEvent.selection;
                },
                onKeyPress: function(e) {
                    if (e.nativeEvent.key === 'Backspace') {
                        var _items_;
                        if (selectionRef.current.start === 0 && selectionRef.current.end === 0 && ((_items_ = items[0]) === null || _items_ === void 0 ? void 0 : _items_.text) === '') {
                            props.onChangeValue(items.slice(1));
                        } else if (selectionRef.current.start === 0 && selectionRef.current.end === value.length) {
                            props.onChangeValue([]);
                        } else if (selectionRef.current.start === 1 && selectionRef.current.end === 1 && items.length === 1 && items[0].text.length === 1) {
                            props.onChangeValue([]);
                        }
                    }
                },
                onChangeValue: function(text) {
                    if (text === '') {
                        // onSelectionChange behaves unexpectely on android. If the entire input is selected and
                        // backspace is pressed, the selection first jumps to the every end of the text before
                        // onKeyPress is called. However, onChangeValue is still called with "" so that gives
                        // us an opportunity to properly respond
                        if (Platform.OS === 'android' && selectionRef.current.start == selectionRef.current.end) {
                            props.onChangeValue([]);
                        }
                        return;
                    }
                    var result = text.split('\n').map(function(t, i) {
                        var _items_i;
                        return _object_spread_props(_object_spread({}, items[i]), {
                            ID: ((_items_i = items[i]) === null || _items_i === void 0 ? void 0 : _items_i.ID) || uuid(),
                            text: props.maxItemLength ? t.slice(0, props.maxItemLength) : t
                        });
                    });
                    props.onChangeValue(props.maxItems ? result.slice(0, props.maxItems) : result);
                },
                value: value,
                inputStyle: {
                    lineHeight: LINE_HEIGHT,
                    marginVertical: 0,
                    paddingStart: 40,
                    paddingTop: 12
                },
                hint: props.hint
            }),
            /*#__PURE__*/ _jsx(View, {
                pointerEvents: "none",
                style: {
                    bottom: 0,
                    left: 40 - 16 - BULLET_SIZE / 2,
                    marginVertical: 0,
                    position: 'absolute',
                    right: 16,
                    top: (props.label ? labelHeight + 5 : 0) + 12 + 1,
                    zIndex: 2
                },
                "aria-hidden": true,
                children: (items.length ? items : [
                    {
                        ID: '',
                        text: ''
                    }
                ]).map(function(param, i) {
                    var text = param.text;
                    var _props_bulletColor;
                    return /*#__PURE__*/ _jsxs(View, {
                        row: true,
                        style: {
                            alignItems: 'flex-start',
                            minHeight: LINE_HEIGHT
                        },
                        spacing: 12,
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: {
                                    marginTop: LINE_HEIGHT / 2 - BULLET_SIZE / 2,
                                    width: BULLET_SIZE,
                                    height: BULLET_SIZE,
                                    backgroundColor: (_props_bulletColor = props.bulletColor) !== null && _props_bulletColor !== void 0 ? _props_bulletColor : 'black',
                                    borderRadius: BULLET_SIZE / 2
                                }
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                flex: 1,
                                children: /*#__PURE__*/ _jsx(Text, {
                                    role: "none",
                                    text: text,
                                    color: "red",
                                    style: {
                                        lineHeight: LINE_HEIGHT,
                                        opacity: 0
                                    },
                                    size: 14
                                })
                            })
                        ]
                    }, i);
                })
            }),
            props.suggestions ? /*#__PURE__*/ _jsx(View, {
                style: {
                    paddingHorizontal: 15
                },
                children: /*#__PURE__*/ _jsx(ButtonAccordion, {
                    text: props.suggestions.accordionText,
                    defaultExpanded: !value.length,
                    style: {
                        paddingBottom: 15,
                        paddingTop: 10
                    },
                    buttonSize: "normal",
                    children: /*#__PURE__*/ _jsx(CheckboxListInput, {
                        testID: "DistractingActivities",
                        checkboxSize: "small",
                        "aria-label": "Suggested items",
                        items: keyBy(props.suggestions.items, function(i) {
                            return i;
                        }),
                        value: items.map(function(i) {
                            return i.text;
                        }),
                        onChangeValue: function(values) {
                            var checkboxItems = items.map(function(i) {
                                return i.text;
                            });
                            var oldValues = checkboxItems.filter(function(v) {
                                return !values.includes(v);
                            });
                            var newValues = values.filter(function(v) {
                                return !checkboxItems.includes(v);
                            });
                            props.onChangeValue(_to_consumable_array(items.filter(function(i) {
                                return !oldValues.includes(i.text);
                            })).concat(_to_consumable_array(newValues.map(function(v) {
                                return {
                                    ID: uuid(),
                                    text: v
                                };
                            }))));
                        }
                    })
                })
            }) : null
        ]
    });
}
